import type {ColGroupDef} from "ag-grid-community";
import {ICellRendererParams} from "ag-grid-community";
import {useEffect, useState} from "react";
import {GreenDiscountDetails} from "../../../api/types/greenDiscount";

export const useMatrixColDefsGreen = ({
                                          matrixData,
                                          editable
                                      }: {
        matrixData: GreenDiscountDetails[];
        editable: boolean;
    }): ColGroupDef[] => {

        // Use State
        const [, setContent] = useState<GreenDiscountDetails[] | null>(null);

        // Use Effect
        useEffect(() => {
            if (matrixData) setContent(JSON.parse(JSON.stringify(matrixData)));
        }, [matrixData]);

        const cellValueSetter = (params: any) => {
            if (params?.newValue !== null && params?.newValue !== undefined) {
                params.newValue = (params.newValue + '').replace(/,/g, '.');
            }
            if (!Number(params.newValue) && params.newValue != 0) {
                return false;
            } else if (params.newValue > 100 && params.newValue < 0) {
                return false;
            }
            params.data[params.colDef.field.split(".")[0]] = Number(params.newValue)
            return true;
        };

        return [{
            headerName: "Green Discount Matrix",
            children: [{
                field: "acrissFuelType",
                minWidth: 120,
                flex: 1,
                editable: false,
                cellRenderer: (params: ICellRendererParams) => params.value,
                cellStyle: {
                    justifyContent: "center",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "2px solid #E0E0E0"
                },
            },
                {
                    field: "discount",
                    minWidth: 120,
                    flex: 1,
                    valueSetter: cellValueSetter,
                    cellEditor: "customEditor",
                    editable: editable,
                    cellRenderer: (params: ICellRendererParams) => {
                        return params.value + "%"
                    },
                    cellStyle: {
                        justifyContent: "center",
                        textAlign: "center",
                        padding: 5,
                        borderRight: "2px solid #E0E0E0"
                    }
                }
            ],
        }]
    }
;
